// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.events-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  border-bottom: 2px solid rgba(200,134,10,0.1);
  padding-bottom: 0;
}

.tab-btn {
  padding: 12px 28px;
  border: none;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-light);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s ease;
}

.tab-btn.active {
  color: var(--gold);
  border-bottom-color: var(--gold);
  font-weight: 600;
}

.category-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 32px;
}

.cat-btn {
  padding: 7px 18px;
  border-radius: 50px;
  border: 1.5px solid rgba(200,134,10,0.25);
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-mid);
  cursor: pointer;
  transition: all 0.2s ease;
}

.cat-btn.active,
.cat-btn:hover {
  background: linear-gradient(135deg, var(--gold), var(--orange));
  border-color: transparent;
  color: var(--white);
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.event-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.event-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.event-emoji {
  font-size: 2.4rem;
  width: 56px;
  height: 56px;
  background: rgba(200,134,10,0.08);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.event-status-badge {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
}

.event-status-badge.upcoming {
  background: rgba(74,110,42,0.12);
  color: var(--green);
}

.event-status-badge.past {
  background: rgba(200,134,10,0.1);
  color: var(--gold-dark);
}

.event-cat-tag {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--orange);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.event-card h3 {
  font-size: 1rem;
  color: var(--brown);
  line-height: 1.4;
}

.event-desc {
  font-size: 0.85rem;
  color: var(--text-mid);
  line-height: 1.7;
  flex: 1 1;
}

.event-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 8px;
  border-top: 1px solid rgba(200,134,10,0.1);
}

.event-detail {
  font-size: 0.82rem;
  color: var(--text-light);
}

.no-results {
  text-align: center;
  padding: 60px 0;
  color: var(--text-light);
}

.no-results h3 {
  margin: 12px 0 8px;
  color: var(--text-mid);
}

.propose-section {
  background: linear-gradient(135deg, var(--cream-dark), var(--cream));
}

.propose-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
}

.propose-text h2 {
  font-size: 1.8rem;
  margin-bottom: 12px;
}

.propose-text p {
  color: var(--text-mid);
  max-width: 580px;
  line-height: 1.8;
}

@media (max-width: 900px) {
  .events-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 560px) {
  .events-grid { grid-template-columns: 1fr; }
  .events-tabs { flex-direction: column; }
  .propose-inner { flex-direction: column; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Events.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,+DAA+D;EAC/D,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe,qCAAqC,EAAE;AACxD;;AAEA;EACE,eAAe,0BAA0B,EAAE;EAC3C,eAAe,sBAAsB,EAAE;EACvC,iBAAiB,sBAAsB,EAAE;AAC3C","sourcesContent":[".events-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n  border-bottom: 2px solid rgba(200,134,10,0.1);\n  padding-bottom: 0;\n}\n\n.tab-btn {\n  padding: 12px 28px;\n  border: none;\n  background: transparent;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--text-light);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s ease;\n}\n\n.tab-btn.active {\n  color: var(--gold);\n  border-bottom-color: var(--gold);\n  font-weight: 600;\n}\n\n.category-filter {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 32px;\n}\n\n.cat-btn {\n  padding: 7px 18px;\n  border-radius: 50px;\n  border: 1.5px solid rgba(200,134,10,0.25);\n  background: transparent;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-mid);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cat-btn.active,\n.cat-btn:hover {\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  border-color: transparent;\n  color: var(--white);\n}\n\n.events-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.event-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.event-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.event-emoji {\n  font-size: 2.4rem;\n  width: 56px;\n  height: 56px;\n  background: rgba(200,134,10,0.08);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.event-status-badge {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n.event-status-badge.upcoming {\n  background: rgba(74,110,42,0.12);\n  color: var(--green);\n}\n\n.event-status-badge.past {\n  background: rgba(200,134,10,0.1);\n  color: var(--gold-dark);\n}\n\n.event-cat-tag {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--orange);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.event-card h3 {\n  font-size: 1rem;\n  color: var(--brown);\n  line-height: 1.4;\n}\n\n.event-desc {\n  font-size: 0.85rem;\n  color: var(--text-mid);\n  line-height: 1.7;\n  flex: 1;\n}\n\n.event-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(200,134,10,0.1);\n}\n\n.event-detail {\n  font-size: 0.82rem;\n  color: var(--text-light);\n}\n\n.no-results {\n  text-align: center;\n  padding: 60px 0;\n  color: var(--text-light);\n}\n\n.no-results h3 {\n  margin: 12px 0 8px;\n  color: var(--text-mid);\n}\n\n.propose-section {\n  background: linear-gradient(135deg, var(--cream-dark), var(--cream));\n}\n\n.propose-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  flex-wrap: wrap;\n}\n\n.propose-text h2 {\n  font-size: 1.8rem;\n  margin-bottom: 12px;\n}\n\n.propose-text p {\n  color: var(--text-mid);\n  max-width: 580px;\n  line-height: 1.8;\n}\n\n@media (max-width: 900px) {\n  .events-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 560px) {\n  .events-grid { grid-template-columns: 1fr; }\n  .events-tabs { flex-direction: column; }\n  .propose-inner { flex-direction: column; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
